// extracted by mini-css-extract-plugin
export default {"delete":"similar-to-you44E4Xb"};